import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { EmptyTableIcon } from '../../../../icons';
import { To, useNavigate } from 'react-router';
import { Button } from '../../../atomic/button';

interface Props {
  variant?: 'rows' | 'results';
  title?: string;
  subTitle?: string;
  linkText?: string;
  toPath?: To;
}

export const EmptyTableOverlay: FC<Props> = ({
  variant = 'results',
  title,
  subTitle,
  linkText,
  toPath
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const linkIsProvided = linkText && toPath;
  return (
    <Box
      sx={{
        position: 'relative',
        zIndex: 1,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: '1rem'
      }}
    >
      {/* <Box> */}
      <EmptyTableIcon width="100%" height={144} color="unset" />
      <Box paddingY="2rem">
        <Typography variant="h3" textAlign="center">
          {title ?? t('common:EMPTY_TABLE_TITLE', { context: variant })}
        </Typography>
        {(linkIsProvided || variant !== 'rows') && (
          <Typography textAlign="center">
            {subTitle ?? t('common:EMPTY_TABLE_INFO', { context: variant })}
          </Typography>
        )}
      </Box>
      {linkIsProvided && variant === 'rows' && (
        <Button variant="secondary" onClick={() => navigate(toPath)}>
          {linkText}
        </Button>
      )}
      {/* </Box> */}
    </Box>
  );
};
